import admin from "../../const/admin";
import netcoServer from '../../apis/netcoServer';
import {CREATE_TIMESTAMP_SERVER} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import getAllTimestampServers from './getAllTimestampServers';
import getTimestampsInfo from '../profile/getTimestampsInfo';
import modalDismiss from '../modal/modalDismiss';
import loadingCall from "../helpers/loadingCall";

const createTimestampServer= (formValues) => async (dispatch, getState) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/SystemService/createTimestampServer', formValues));
  handleResponse(dispatch, response, CREATE_TIMESTAMP_SERVER, data => onSuccessPayload(data, getState), null, [getAllTimestampServers, getTimestampsInfo, modalDismiss]);
};

const onSuccessPayload = (data, getState) => {
  return infoPayload('success', admin[getState().auth.language].timestampServerAdded);
};
export default createTimestampServer;